import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'
import { Button } from './Button'

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  width: 100%;
  justify-content: center;
  & img {
    width: 100%;
    // height: 350px;
    @media (max-width: 840px) {
      max-width: 150px;
      width: 100%;
    }
  }
  @media (max-width: 840px) {
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 768px) {
    padding-top: 30px !important;
    & img {
      // height: 170px !important;
    }
  }
`
const ProductImage = styled.div`
  display: block;
  flex-basis: ${props => (props.flexBasis ? props.flexBasis : '50%')};
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  display: flex;
  img {
    max-width: ${props => (props.imgSize ? '200px' : '100%')};
  }
  @media (max-width: 840px) {
    justify-content: center;
    width: 100%;
  }
`
const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding: ${props => (props.paddingPixel ? props.paddingPixel : '0px')};
  flex-basis: ${props => (props.flexBasis ? props.flexBasis : '50%')};
  flex-wrap: wrap;
  & a {
    display: flex;
  }
  @media (max-width: 840px) {
    padding: 40px 0 0 0;
    width: 100%;
    align-items: center;
  }
  & > p {
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.8px;
    color: #333333;
    padding-bottom: 4px;
    font-weight: 500;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    font-weight: 400;
    line-height: 1.2;
    padding-bottom: 10px;
    letter-spacing: 2.4px;
    font-weight: 400;
    color: #333333;
    margin: 0;
    @media (max-width: 840px) {
      font-size: 30px;
    }
  }
  & > p:nth-child(3) {
    // width: 448px;
    margin-bottom: 20px;
    color: #666666;
    font-weight: 400;
  }
  & > ul {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.8;
    letter-spacing: 0.1px;
    margin-bottom: 20px;
    padding-left: 26px;
    & li {
      font-weight: 400;
      font-size: 16px;
      line-height: 1.4;
      padding-bottom: 10px;
    }
  }
  @media (max-width: 768px) {
    flex-wrap: wrap;
    & > p {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.8 !important;
      letter-spacing: 0.1px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.25 !important;
      letter-spacing: 1.2px;
    }
    & > ul {
      margin-bottom: 30px;
      & > li {
        font-size: 14px;
        font-weight: normal;
        line-height: 1.57 !important;
        letter-spacing: 0.1px;
      }
    }
  }
`
export class Product extends PureComponent {
  render() {
    const { paragraph = false, imageLeft = true, defaultImage = true, img = '../static/laptop.jpg' } = this.props
    return (
      <Fragment>
        {imageLeft ? (
          <ContentWrapper>
            {defaultImage ? (
              <ProductImage flexBasis={this.props.flexBasis} imgSize={this.props.imgSize}>
                <img src={img} alt="Laptop" />
              </ProductImage>
            ) : (
              <img src={require('../static/laptopwithmobile.png')} alt="Laptop" />
            )}
            <InnerContent paddingPixel={this.props.contentPadding} flexBasis={this.props.flexBasis}>
              <p>{this.props.title}</p>
              <p>{this.props.productName}</p>
              {!paragraph ? (
                <ul>
                  <li>{this.props.featureOne}</li>
                  <li>{this.props.featureTwo}</li>
                  <li>{this.props.featureThree}</li>
                  <li>{this.props.featureFour}</li>
                </ul>
              ) : (
                <p>{this.props.createParagraph}</p>
              )}
              {this.props.titleName !== '' ? (
                <a href={this.props.redirectTo} target="_blank" width={176} rel="noopener noreferrer">
                  <Button
                    background="#fff"
                    border={'1px solid rgba(0, 0, 0, 0.2)'}
                    width={176}
                    color={'#333333'}
                    title={this.props.titleName}
                  />
                </a>
              ) : (
                ''
              )}
            </InnerContent>
          </ContentWrapper>
        ) : (
          <ContentWrapper>
            <InnerContent>
              <p>{this.props.title}</p>
              <p>{this.props.productName}</p>
              {!paragraph ? (
                <ul>
                  <li>{this.props.featureOne}</li>
                  <li>{this.props.featureTwo}</li>
                  <li>{this.props.featureThree}</li>
                  <li>{this.props.featureFour}</li>
                </ul>
              ) : (
                <p>{this.props.createParagraph}</p>
              )}
              {this.props.titleName !== '' ? (
                <a href={this.props.titleName} target="_blank" width={176} rel="noopener noreferrer">
                  <Button
                    background="#fff"
                    border={'1px solid rgba(0, 0, 0, 0.2)'}
                    width={176}
                    color={'#333333'}
                    title={this.props.titleName}
                  />
                </a>
              ) : (
                ''
              )}
            </InnerContent>
            {defaultImage ? (
              <img src={require('../static/laptop.jpg')} alt="Laptop" />
            ) : (
              <img src={require('../static/laptopwithmobile.png')} alt="Laptop" />
            )}
          </ContentWrapper>
        )}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product.js